export const SET_LIGHT = 'SET_LIGHT';
export const ALL_LIGHTS_OFF = 'ALL_LIGHTS_OFF';